import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import TicketModal from "@/atomic/organisms/TicketModal";
import { Suspense } from "react";

export default function TicketView({
  tickets,
  openInvoice,
  isLoading,
  errorTickets,
  tryAgain,
  errorInvoice,
  goBack,
  toggleModal,
  isVisibleModal,
  generatePDF,
  invoice,
}: PropsView) {
  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header title="Recibos" hasLeftButton goBack={goBack} />
      <main className="flex-1 w-full flex justify-center min-h-0 bg-background">
        <article className="w-full max-w-[480px] px-6 pt-6 pb-8 flex flex-col flex-1 min-h-0">
          <div className="flex-1 min-h-0 overflow-y-auto pb-4">
            <h2 className="text-text text-[22px] leading-tight font-primary font-semibold tracking-tight">
              Últimos recibos
            </h2>
            <div className="flex flex-col mt-6 gap-4">
              {tickets?.map((item, index) => (
                <div className="w-full" key={index}>
                  <div className="w-full flex flex-row justify-between items-center">
                    <p className="text-text text-base font-primary">
                      {item?.date}
                    </p>
                    <button type="button" onClick={() => openInvoice(item)}>
                      <p className="text-white bg-primary text-xs font-primary font-semibold px-3 py-1.5 rounded-lg">
                        Ver recibo
                      </p>
                    </button>
                  </div>
                  <div className="w-full flex flex-row justify-between mt-1 items-center">
                    <p className="text-tertiary text-xs font-primary">Valor</p>
                    <p className="text-text text-base font-primary font-bold">
                      R$ {item?.price}
                    </p>
                  </div>
                  {index < (tickets?.length ?? 0) - 1 && (
                    <div className="w-full h-px bg-border mt-3" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </article>
      </main>
      {errorTickets && (
        <Suspense fallback={null}>
          <Modal
            title="Atenção"
            message="Não foi possível trazer seus tickets."
            actionMessage="Tentar novamente"
            action={tryAgain}
            actionSecondMessage="Ok"
            actionSecond={toggleModal}
          />
        </Suspense>
      )}
      {errorInvoice && (
        <Suspense fallback={null}>
          <Modal
            title="Atenção"
            message="Não foi possível baixar o PDF. Tente novamente mais tarde."
            actionMessage="Ok"
            action={toggleModal}
          />
        </Suspense>
      )}
      {isVisibleModal && (
        <Suspense fallback={null}>
          <TicketModal
            toggleModal={toggleModal}
            invoice={invoice}
            generatePDF={generatePDF}
          />
        </Suspense>
      )}
      {isLoading && (
        <Suspense fallback={null}>
          <Loading />
        </Suspense>
      )}
    </div>
  );
}
